export const FORM_FLOW_CONTROL = {
  SIGN_UP_FORM: "signUpForm",
  SIGN_IN_FORM: "signInForm",
  VERIFY_ACCOUNT_FORM: "verifyAccountOtpForm",
  ACCOUNT_VERIFICATION_FORM: "accountHoldrMobileForm",
  RESET_PASSWORD_FORM: "resetPasswordForm",
  BUILD_PROFILE_FORM: "buildProfileSignupForm",
  ACCOUNT_HOLDER_UPDATE_FORM: "accountHolderUpdateForm",
  MEMBER_SOURCE_SKIT_UPLOAD_PERMISSIONS: "memberSourceSkitUploadPermissions",
  MEMBER_VERIFICATION_NEEDED: "verifyMemberRequiredFlowWhenLoggedin",
  SECURITY_CHECK: "is_login_approved_crash_malicious", // used for checking suspisious users
};
